<app-charging></app-charging>
<app-modal></app-modal>

<div class="application-form-container">
  <div class="header">
    <div class="profile-section">
      <div class="title-section">
        <h2>
          {{ role === 2 ? 'Propietario' :
          role === 1 ? 'Arrendatario' :
          'Codeudor' }} - Formulario de Solicitud
        </h2>
      </div>
    </div>

    <div class="progress-steps">
      <ng-container *ngFor="let step of visibleSteps; let last = last">
        <div class="step" [class.active]="currentStep === step.number">
          <div class="step-content">
            <span class="step-number" [class.completed]="currentStep > step.number">
              <ng-container *ngIf="currentStep > step.number; else stepNumber">
                <i class="fas fa-check"></i>
              </ng-container>
              <ng-template #stepNumber>{{ step.number }}</ng-template>
            </span>
            <span class="step-name">{{ step.name }}</span>
          </div>
        </div>
        <div class="step-separator" *ngIf="!last"></div>
      </ng-container>
    </div>
  </div>

  <div class="form-container">
    <button class="close-button" (click)="goBack()">×</button>

    <!-- Step 1: General -->
    <ng-container *ngIf="visibleSteps[currentStep - 1]?.originalId === 1">
      <!-- Formulario para Persona Natural -->
      <form *ngIf="personType === 'N'" [formGroup]="generalForm" (ngSubmit)="onSubmit()" class="step-form">
        <!-- Fila 1: Identificación -->
        <div class="form-row four-columns">
          <div class="form-group">
            <label>Tipo de Documento: <span class="required-field">*</span></label>
            <select formControlName="idDocumentType">
              <option [ngValue]="null" disabled selected hidden>Seleccione...</option>
              <option *ngFor="let type of documentTypes" [value]="type.codigoTipoDocumento">
                {{type.nombreTipoDocumento}}
              </option>
            </select>
            <small class="error-message"
              *ngIf="generalForm.get('idDocumentType')?.touched && generalForm.get('idDocumentType')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Número de Documento: <span class="required-field">*</span></label>
            <input type="text" formControlName="documentNumber">
            <small class="error-message"
              *ngIf="generalForm.get('documentNumber')?.touched && generalForm.get('documentNumber')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Departamento de Expedición Documento: <span class="required-field">*</span></label>
            <select formControlName="expeditionDepartment">
              <option [ngValue]="null" disabled selected hidden>Seleccione...</option>
              <option *ngFor="let dept of departments" [value]="dept.codigoDepartamento">
                {{dept.nombreDepartamento}}
              </option>
            </select>
            <small class="error-message"
              *ngIf="generalForm.get('expeditionDepartment')?.touched && generalForm.get('expeditionDepartment')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Lugar de Expedición Documento: <span class="required-field">*</span></label>
            <select formControlName="expeditionCity">
              <option value="null" selected hidden>Seleccione...</option>
              <option *ngFor="let mun of expeditionMunicipalities" [value]="mun.codigoMunicipio">
                {{mun.nombreMunicipio}}
              </option>
            </select>
            <small class="error-message"
              *ngIf="generalForm.get('expeditionCity')?.touched && generalForm.get('expeditionCity')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>
        </div>

        <!-- Fila 2: Nombres -->
        <div class="form-row four-columns">
          <div class="form-group">
            <label>Primer Apellido: <span class="required-field">*</span></label>
            <input type="text" formControlName="firstLastName" appUppercase>
            <small class="error-message"
              *ngIf="generalForm.get('firstLastName')?.touched && generalForm.get('firstLastName')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Segundo Apellido:</label>
            <input type="text" formControlName="secondLastName" appUppercase>
          </div>

          <div class="form-group">
            <label>Primer Nombre: <span class="required-field">*</span></label>
            <input type="text" formControlName="firstName" appUppercase>
            <small class="error-message"
              *ngIf="generalForm.get('firstName')?.touched && generalForm.get('firstName')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Segundo Nombre:</label>
            <input type="text" formControlName="secondName" appUppercase>
          </div>
        </div>

        <!-- Fila 3: Fechas y Nacionalidad -->
        <div class="form-row four-columns">
          <div class="form-group">
            <label>Fecha de Expedición Documento: <span class="required-field">*</span></label>
            <input type="date" formControlName="expeditionDate">
            <small class="error-message"
              *ngIf="generalForm.get('expeditionDate')?.touched && generalForm.get('expeditionDate')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Fecha de Nacimiento: <span class="required-field">*</span></label>
            <input type="date" formControlName="birthDate">
            <small class="error-message"
              *ngIf="generalForm.get('birthDate')?.touched && generalForm.get('birthDate')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Lugar de Nacimiento: <span class="required-field">*</span></label>
            <input type="text" formControlName="birthplace" appUppercase>
            <small class="error-message"
              *ngIf="generalForm.get('birthplace')?.touched && generalForm.get('birthplace')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Tipo de Nacionalidad: <span class="required-field">*</span></label>
            <input type="text" formControlName="nationalityType" appUppercase (keypress)="allowOnlyLetters($event)">
            <small class="error-message"
              *ngIf="generalForm.get('nationalityType')?.touched && generalForm.get('nationalityType')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>
        </div>

        <!-- Fila 4: Contacto -->
        <div class="form-row four-columns">
          <div class="form-group">
            <label>Dirección: <span class="required-field">*</span></label>
            <input type="text" formControlName="address" appUppercase>
            <small class="error-message"
              *ngIf="generalForm.get('address')?.touched && generalForm.get('address')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Teléfono Fijo: <span class="required-field">*</span></label>
            <input type="tel" formControlName="phone" pattern="[0-9]*" inputmode="numeric">
          </div>

          <div class="form-group">
            <label>Teléfono Celular: <span class="required-field">*</span></label>
            <input type="tel" formControlName="mobilePhone" pattern="[0-9]*" inputmode="numeric">
            <small class="error-message"
              *ngIf="generalForm.get('mobilePhone')?.touched && generalForm.get('mobilePhone')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Correo Electrónico: <span class="required-field">*</span></label>
            <input type="email" formControlName="email">
            <small class="error-message"
              *ngIf="generalForm.get('email')?.touched && generalForm.get('email')?.hasError('required')">
              Este campo es requerido
            </small>
            <small class="error-message"
              *ngIf="generalForm.get('email')?.touched && generalForm.get('email')?.hasError('email')">
              Ingrese un correo electrónico válido
            </small>
          </div>
        </div>

        <!-- Fila 5: Localización y Estado -->
        <div class="form-row four-columns">
          <div class="form-group">
            <label>Departamento: <span class="required-field">*</span></label>
            <select formControlName="department">
              <option value="null" disabled selected hidden>Seleccione...</option>
              <option *ngFor="let dept of departments" [value]="dept.codigoDepartamento">
                {{dept.nombreDepartamento}}
              </option>
            </select>
            <small class="error-message"
              *ngIf="generalForm.get('department')?.touched && generalForm.get('department')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Ciudad/Municipio: <span class="required-field">*</span></label>
            <select formControlName="city">
              <option value="null" disabled selected hidden>Seleccione...</option>
              <option *ngFor="let mun of residenceMunicipalities" [value]="mun.codigoMunicipio">
                {{mun.nombreMunicipio}}
              </option>
            </select>
            <small class="error-message"
              *ngIf="generalForm.get('city')?.touched && generalForm.get('city')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Género: <span class="required-field">*</span></label>
            <select formControlName="gender">
              <option value="null" disabled selected hidden>Seleccione...</option>
              <option *ngFor="let gender of genders" [value]="gender.codTipoGenero">
                {{gender.strNombreGenero | uppercase}}
              </option>
            </select>
            <small class="error-message"
              *ngIf="generalForm.get('gender')?.touched && generalForm.get('gender')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Estado Civil: <span class="required-field">*</span></label>
            <select formControlName="maritalStatus">
              <option value="null" disabled selected hidden>Seleccione...</option>
              <option *ngFor="let status of maritalStatuses" [value]="status.codigoEstadoCivil">
                {{status.nombreEstadoCivil}}
              </option>
            </select>
            <small class="error-message"
              *ngIf="generalForm.get('maritalStatus')?.touched && generalForm.get('maritalStatus')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>
        </div>

        <!-- Fila 6: Información Adicional -->
        <div class="form-row three-columns">
          <div class="form-group">
            <label>Dirección de Envio Correspondencia: <span class="required-field">*</span></label>
            <input type="text" formControlName="mailingAddress" appUppercase>
            <small class="error-message"
              *ngIf="generalForm.get('mailingAddress')?.touched && generalForm.get('mailingAddress')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Gastos Familiares Mensuales: <span class="required-field">*</span></label>
            <div class="input-currency">
              <span class="currency-symbol">$</span>
              <input type="text" formControlName="monthlyExpenses" (input)="formatNumber($event)">
            </div>
            <small class="error-message"
              *ngIf="generalForm.get('monthlyExpenses')?.touched && generalForm.get('monthlyExpenses')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Número de Personas a Cargo: <span class="required-field">*</span></label>
            <input type="number" formControlName="dependents" min="0">
            <small class="error-message"
              *ngIf="generalForm.get('dependents')?.touched && generalForm.get('dependents')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>
        </div>

        <button type="submit" [disabled]="!generalForm.valid" class="continue-button">
          Continuar
        </button>
      </form>

      <!-- Formulario para Persona Jurídica -->
      <form *ngIf="personType === 'J'" [formGroup]="generalForm" (ngSubmit)="onSubmit()" class="step-form">
        <!-- Fila 1: Información básica -->
        <div class="form-row three-columns">
          <div class="form-group">
            <label>Razón Social: <span class="required-field">*</span></label>
            <input type="text" formControlName="firstLastName" appUppercase>
            <small class="error-message"
              *ngIf="generalForm.get('firstLastName')?.touched && generalForm.get('firstLastName')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>NIT: <span class="required-field">*</span></label>
            <input type="text" formControlName="documentNumber">
            <small class="error-message"
              *ngIf="generalForm.get('documentNumber')?.touched && generalForm.get('documentNumber')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Correo Electrónico: <span class="required-field">*</span></label>
            <input type="email" formControlName="email">
            <small class="error-message"
              *ngIf="generalForm.get('email')?.touched && generalForm.get('email')?.hasError('required')">
              Este campo es requerido
            </small>
            <small class="error-message"
              *ngIf="generalForm.get('email')?.touched && generalForm.get('email')?.hasError('email')">
              Ingrese un correo electrónico válido
            </small>
          </div>
        </div>

        <!-- Tipo de Empresa -->
        <div class="form-row radio-row">
          <div class="form-group radio-group">
            <label>Tipo de Empresa: <span class="required-field">*</span></label>
            <div class="radio-options empresa-options" role="radiogroup">
              <label *ngFor="let tipo of tiposEmpresa">
                <input type="radio" formControlName="tipoEmpresa" [value]="tipo.id">
                {{tipo.nombre}}
              </label>
            </div>
            <small class="error-message"
              *ngIf="generalForm.get('tipoEmpresa')?.touched && generalForm.get('tipoEmpresa')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>
        </div>

        <!-- Tipo de Sociedad -->
        <div class="form-row radio-row">
          <div class="form-group radio-group">
            <label>Tipo de Sociedad: <span class="required-field">*</span></label>
            <div class="radio-options sociedad-options" role="radiogroup">
              <label *ngFor="let tipo of tiposSociedad">
                <input type="radio" formControlName="tipoSociedad" [value]="tipo.id">
                {{tipo.nombre}}
              </label>
            </div>
            <small class="error-message"
              *ngIf="generalForm.get('tipoSociedad')?.touched && generalForm.get('tipoSociedad')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>
        </div>

        <!-- Fila 4: Actividad Económica -->
        <div class="form-row two-columns">
          <div class="form-group">
            <label>Actividad Económica: <span class="required-field">*</span></label>
            <select formControlName="actividadEconomica" (change)="onActividadEconomicaChangeJuridica()">
              <option value="null" disabled selected hidden>Seleccione...</option>
              <option *ngFor="let actividad of actividadesEconomicas" [ngValue]="actividad.codigoActividadEconomica">
                {{actividad.nombreActividadEconomica}}
              </option>
            </select>
            <small class="error-message" *ngIf="laboralForm.get('actividadEconomica')?.touched && laboralForm.get('actividadEconomica')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Código CIIU:</label>
            <input type="text" formControlName="codigoCiiu" [readonly]="true">
          </div>
        </div>

        <!-- Fila 5: Datos Oficina Principal -->
        <div class="form-row four-columns">
          <div class="form-group">
            <label>Dirección Oficina: <span class="required-field">*</span></label>
            <input type="text" formControlName="address" appUppercase>
            <small class="error-message"
              *ngIf="generalForm.get('address')?.touched && generalForm.get('address')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Teléfono Oficina: <span class="required-field">*</span></label>
            <input type="tel" formControlName="phone" pattern="[0-9]*" inputmode="numeric">
            <small class="error-message"
              *ngIf="generalForm.get('phone')?.touched && generalForm.get('phone')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Departamento Oficina: <span class="required-field">*</span></label>
            <select formControlName="department">
              <option value="null" disabled selected hidden>Seleccione...</option>
              <option *ngFor="let dept of departments" [value]="dept.codigoDepartamento">
                {{dept.nombreDepartamento}}
              </option>
            </select>
            <small class="error-message"
              *ngIf="generalForm.get('department')?.touched && generalForm.get('department')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Ciudad/Municipio Oficina: <span class="required-field">*</span></label>
            <select formControlName="city">
              <option value="null" disabled selected hidden>Seleccione...</option>
              <option *ngFor="let mun of residenceMunicipalities" [value]="mun.codigoMunicipio">
                {{mun.nombreMunicipio}}
              </option>
            </select>
            <small class="error-message"
              *ngIf="generalForm.get('city')?.touched && generalForm.get('city')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>
        </div>

        <!-- Fila 6: Datos Sucursal -->
        <div class="form-row four-columns">
          <div class="form-group">
            <label>Dirección Sucursal:</label>
            <input type="text" formControlName="direccionSucursal" appUppercase>
          </div>

          <div class="form-group">
            <label>Teléfono Oficina Sucursal:</label>
            <input type="tel" formControlName="telefonoSucursal" pattern="[0-9]*" inputmode="numeric">
          </div>

          <div class="form-group">
            <label>Departamento Sucursal:<span class="required-field">*</span></label>
            <select formControlName="departamentoSucursal">
              <option [ngValue]="null" disabled selected hidden>Seleccione...</option>
              <option *ngFor="let dept of departments" [value]="dept.codigoDepartamento">
                {{dept.nombreDepartamento}}
              </option>
            </select>
            <small class="error-message"
              *ngIf="generalForm.get('departamentoSucursal')?.touched && generalForm.get('departamentoSucursal')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Ciudad/Municipio Sucursal: <span class="required-field">*</span></label>
            <select formControlName="ciudadSucursal">
              <option [ngValue]="null" disabled selected hidden>Seleccione...</option>
              <option *ngFor="let mun of sucursalMunicipalities" [value]="mun.codigoMunicipio">
                {{mun.nombreMunicipio}}
              </option>
            </select>
            <small class="error-message"
              *ngIf="generalForm.get('ciudadSucursal')?.touched && generalForm.get('ciudadSucursal')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>
        </div>

        <button type="submit" [disabled]="!generalForm.valid" class="continue-button">
          Continuar
        </button>
      </form>
    </ng-container>

    <!-- Step 2: Laboral -->
    <ng-container *ngIf="visibleSteps[currentStep - 1]?.originalId === 2">
      <form [formGroup]="laboralForm" (ngSubmit)="onSubmit()" class="step-form">
        <!-- Primera fila -->
        <div class="form-row four-columns">
          <div class="form-group">
            <label>Actividad Económica: <span class="required-field">*</span></label>
            <select formControlName="actividadEconomica" [class.readonly-select]="isPensionado" (change)="onActividadEconomicaChange()">
              <option value="null" disabled selected hidden>Seleccione...</option>
              <option *ngFor="let actividad of actividadesEconomicas" [ngValue]="actividad.codigoActividadEconomica">
                {{actividad.nombreActividadEconomica}}
              </option>
            </select>
            <small class="error-message" *ngIf="laboralForm.get('actividadEconomica')?.touched && laboralForm.get('actividadEconomica')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Código CIIU:</label>
            <input type="text" formControlName="codigoCiiu" [readonly]="true">
          </div>

          <div class="form-group">
            <label>{{ getPensionadoLabels().nombreEmpresa }}: <span class="required-field">*</span></label>
            <input type="text" formControlName="nombreEmpresa" appUppercase>
            <small class="error-message" *ngIf="laboralForm.get('nombreEmpresa')?.touched && laboralForm.get('nombreEmpresa')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Área de Trabajo: <span class="required-field">*</span></label>
            <input type="text" formControlName="areaTrabajo" appUppercase [readonly]="isPensionado">
            <small class="error-message" *ngIf="laboralForm.get('areaTrabajo')?.touched && laboralForm.get('areaTrabajo')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>
        </div>

        <!-- Segunda fila -->
        <div class="form-row three-columns">
          <div class="form-group">
            <label>Profesión: <span class="required-field">*</span></label>
            <select formControlName="profesion">
              <option value="null" disabled selected hidden>Seleccione...</option>
              <option *ngFor="let ocupacion of tiposOcupacion" [ngValue]="ocupacion.codigoOcupacion">
                {{ocupacion.nombreOcupacion}}
              </option>
            </select>
            <small class="error-message" *ngIf="laboralForm.get('profesion')?.touched && laboralForm.get('profesion')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>Cargo: <span class="required-field">*</span></label>
            <select formControlName="cargo" [class.readonly-select]="isPensionado">
              <option value="null" disabled selected hidden>Seleccione...</option>
              <option *ngFor="let cargo of listaCargos" [ngValue]="cargo.codCargo">
                {{cargo.txtDesc}}
              </option>
            </select>
            <small class="error-message" *ngIf="laboralForm.get('cargo')?.touched && laboralForm.get('cargo')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>{{ getPensionadoLabels().fechaIngreso }}: <span class="required-field">*</span></label>
            <input type="date" formControlName="fechaIngreso" [max]="currentYear + '-12-31'">
            <small class="error-message" *ngIf="laboralForm.get('fechaIngreso')?.touched && laboralForm.get('fechaIngreso')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>
          </div>

        <!-- Tercera fila -->
        <div class="form-row four-columns">
          <div class="form-group">
            <label>{{ getPensionadoLabels().direccionOficina }}: <span class="required-field">*</span></label>
            <input type="text" formControlName="direccionOficina" appUppercase [readonly]="isPensionado">
            <small class="error-message" *ngIf="laboralForm.get('direccionOficina')?.touched && laboralForm.get('direccionOficina')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>{{ getPensionadoLabels().telefonoOficina }}: <span class="required-field">*</span></label>
            <input type="tel" formControlName="telefonoOficina" pattern="[0-9]*" inputmode="numeric" [readonly]="isPensionado">
            <small class="error-message" 
              *ngIf="laboralForm.get('telefonoOficina')?.touched && laboralForm.get('telefonoOficina')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>{{ getPensionadoLabels().departamentoOficina }}: <span class="required-field">*</span></label>
            <select formControlName="departamentoOficina" (change)="onDepartamentoOficinaChange()">
              <option [ngValue]="null" disabled selected hidden>Seleccione...</option>
              <option *ngFor="let dept of departments" [value]="dept.codigoDepartamento">
                {{dept.nombreDepartamento}}
              </option>
            </select>
            <small class="error-message" 
              *ngIf="laboralForm.get('departamentoOficina')?.touched && laboralForm.get('departamentoOficina')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>

          <div class="form-group">
            <label>{{ getPensionadoLabels().ciudadOficina }}: <span class="required-field">*</span></label>
            <select formControlName="ciudadOficina" [disabled]="!laboralForm.get('departamentoOficina')?.value">
              <option [ngValue]="null" disabled selected hidden>Seleccione...</option>
              <option *ngFor="let mun of oficinaMunicipalities" [value]="mun.codigoMunicipio">
                {{mun.nombreMunicipio}}
              </option>
            </select>
            <small class="error-message"
             *ngIf="laboralForm.get('ciudadOficina')?.touched && laboralForm.get('ciudadOficina')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>
        </div>

        <button type="submit" [disabled]="!laboralForm.valid" class="continue-button">
          Continuar
        </button>
      </form>
    </ng-container>

    <!-- Step 3: Financiera -->
    <ng-container *ngIf="visibleSteps[currentStep - 1]?.originalId === 3">
      <form [formGroup]="financieraForm" (ngSubmit)="onSubmit()" class="step-form">
        <ng-container *ngIf="personType === 'J'">
          <!-- Primera fila -->
          <div class="form-row two-columns">
            <div class="form-group">
              <label>Ingresos Mensuales: <span class="required-field">*</span></label>
              <div class="input-currency">
                <span class="currency-symbol">$</span>
                <input type="text" formControlName="ingresosMensuales" (input)="formatNumber($event)">
              </div>
              <small class="error-message" *ngIf="financieraForm.get('ingresosMensuales')?.touched && financieraForm.get('ingresosMensuales')?.hasError('required')">
                Este campo es requerido
              </small>
            </div>

            <div class="form-group">
              <label>Egresos Mensuales: <span class="required-field">*</span></label>
              <div class="input-currency">
                <span class="currency-symbol">$</span>
                <input type="text" formControlName="egresosMensuales" (input)="formatNumber($event)">
              </div>
              <small class="error-message" *ngIf="financieraForm.get('egresosMensuales')?.touched && financieraForm.get('egresosMensuales')?.hasError('required')">
                Este campo es requerido
              </small>
            </div>
          </div>

          <!-- Segunda fila -->
          <div class="form-row three-columns">
            <div class="form-group">
              <label>Activos: <span class="required-field">*</span></label>
              <div class="input-currency">
                <span class="currency-symbol">$</span>
                <input type="text" formControlName="activos" (input)="formatNumber($event)">
              </div>
              <small class="error-message" *ngIf="financieraForm.get('activos')?.touched && financieraForm.get('activos')?.hasError('required')">
                Este campo es requerido
              </small>
            </div>

            <div class="form-group">
              <label>Pasivos: <span class="required-field">*</span></label>
              <div class="input-currency">
                <span class="currency-symbol">$</span>
                <input type="text" formControlName="pasivos" (input)="formatNumber($event)">
              </div>
              <small class="error-message" *ngIf="financieraForm.get('pasivos')?.touched && financieraForm.get('pasivos')?.hasError('required')">
                Este campo es requerido
              </small>
            </div>

            <div class="form-group">
              <label>Patrimonio: <span class="required-field">*</span></label>
              <div class="input-currency">
                <span class="currency-symbol">$</span>
                <input type="text" formControlName="patrimonio" (input)="formatNumber($event)">
              </div>
              <small class="error-message" *ngIf="financieraForm.get('patrimonio')?.touched && financieraForm.get('patrimonio')?.hasError('required')">
                Este campo es requerido
              </small>
            </div>
          </div>
        </ng-container>

        <ng-container *ngIf="personType === 'N'">
          <!-- Primera fila -->
          <div class="form-row two-columns">
            <div class="form-group">
              <label>Ingresos Mensuales: <span class="required-field">*</span></label>
              <div class="input-currency">
                <span class="currency-symbol">$</span>
                <input type="text" formControlName="ingresosMensuales" (input)="formatNumber($event)">
              </div>
              <small class="error-message" *ngIf="financieraForm.get('ingresosMensuales')?.touched && 
               financieraForm.get('ingresosMensuales')?.hasError('required')">
                Este campo es requerido
              </small>
            </div>

            <div class="form-group">
              <label>Otros Ingresos Mensuales:</label>
              <div class="input-currency">
                <span class="currency-symbol">$</span>
                <input type="text" formControlName="otrosIngresos" (input)="formatNumber($event)">
              </div>
            </div>
          </div>

          <!-- Campo condicional para Concepto Otros Ingresos -->
          <div class="form-row" *ngIf="showConceptoOtrosIngresos">
            <div class="form-group">
              <label>Concepto Otros Ingresos:</label>
              <input type="text" formControlName="conceptoOtrosIngresos" appUppercase>
            </div>
          </div>

          <!-- Segunda fila -->
          <div class="form-row two-columns">
            <div class="form-group">
              <label>Total Ingreso Mensual:</label>
              <div class="input-currency">
                <span class="currency-symbol">$</span>
                <input type="text" formControlName="totalIngresoMensual" [readonly]="true">
              </div>
            </div>

            <div class="form-group">
              <label>Total Egreso Mensual: <span class="required-field">*</span></label>
              <div class="input-currency">
                <span class="currency-symbol">$</span>
                <input type="text" formControlName="totalEgresoMensual" (input)="formatNumber($event)">
              </div>
              <small class="error-message" *ngIf="financieraForm.get('totalEgresoMensual')?.touched && 
               financieraForm.get('totalEgresoMensual')?.hasError('required')">
                Este campo es requerido
              </small>
            </div>
          </div>

          <!-- Tercera fila -->
          <div class="form-row two-columns">
            <div class="form-group">
              <label>Total Activos:</label>
              <div class="input-currency">
                <span class="currency-symbol">$</span>
                <input type="text" formControlName="totalActivos" (input)="formatNumber($event)">
              </div>
            </div>

            <div class="form-group">
              <label>Total Pasivos: <span class="required-field">*</span></label>
              <div class="input-currency">
                <span class="currency-symbol">$</span>
                <input type="text" formControlName="totalPasivos" (input)="formatNumber($event)">
              </div>
              <small class="error-message" *ngIf="financieraForm.get('totalPasivos')?.touched && 
               financieraForm.get('totalPasivos')?.hasError('required')">
                Este campo es requerido
              </small>
            </div>
          </div>
        </ng-container>

        <!-- Sección de Autorizaciones -->
        <div class="authorization-section">
          <h3>Autorización para Reporte a Centrales de Riesgo</h3>
          <div class="authorization-content">
            <p>Autorizo de manera previa, expresa y voluntaria a <strong>ASEGURADORA SOLIDARIA DE COLOMBIA ENTIDAD
                COOPERATIVA</strong>, o a quien represente sus derechos a consultar, almacenar, administrar, transferir,
              procesar y reportar mi información a las Centrales de Información o bases de datos debidamente
              constituidas respecto al comportamiento crediticio, financiero y comercial.</p>
            <div class="checkbox-container">
              <input type="checkbox" formControlName="autorizacionCentrales" id="autorizacionCentrales">
            </div>
          </div>
          <small class="error-message" *ngIf="financieraForm.get('autorizacionCentrales')?.touched &&  financieraForm.get('autorizacionCentrales')?.hasError('required')">
            Debe aceptar la autorización
          </small>
        </div>

        <!-- Sección de Operaciones Internacionales -->
        <div class="international-section">
          <h3>Actividad En Operaciones Internacionales</h3>
          <div class="checkbox-group">
            <div class="checkbox-item">
              <input type="checkbox" formControlName="actividadExtranjera" id="actividadExtranjera">
              <label for="actividadExtranjera">¿Realiza actividades con moneda extranjera?</label>
            </div>
            <div class="checkbox-item">
              <input type="checkbox" formControlName="obligacionesEEUU" id="obligacionesEEUU">
              <label for="obligacionesEEUU">¿Es usted sujeto de obligaciones tributarias en los Estados Unidos?</label>
            </div>
          </div>
        </div>

        <div *ngIf="financieraForm.get('actividadExtranjera')?.value" class="foreign-activity-section">
          <div class="checkbox-row">
            <label *ngFor="let op of ['importaciones', 'exportaciones', 'inversiones', 'transferencias', 'prestamos', 'pagoServicios', 'otro']">
              <input type="checkbox" [formControlName]="op">
              {{op | titlecase}}
            </label>
          </div>
        
          <div class="form-row">
            <div class="form-group">
              <label>Tipo de Producto:</label>
              <input type="text" formControlName="tipoProducto">
            </div>
            <div class="form-group">
              <label>Identificación del producto:</label>
              <input type="text" formControlName="identificacionProducto">
            </div>
            <div class="form-group">
              <label>Entidad:</label>
              <input type="text" formControlName="entidad">
            </div>
            <div class="form-group">
              <label>Monto:</label>
              <div class="input-currency">
                <span class="currency-symbol">$</span>
                <input type="text" formControlName="monto" (input)="formatNumber($event)">
              </div>
            </div>
            <div class="form-group">
              <label>País:</label>
              <select formControlName="paisMoneda">
                <option value="null" disabled selected hidden>Seleccione...</option>
                <option *ngFor="let pais of paises" [value]="pais.codigoPais">
                  {{pais.nombrePais}}
                </option>
              </select>
            </div>
            <div class="form-group">
              <label>Ciudad:</label>
              <input type="text" formControlName="ciudad">
            </div>
            <div class="form-group">
              <label>Moneda:</label>
              <select formControlName="moneda">
                <option value="null" disabled selected hidden>Seleccione...</option>
                <option *ngFor="let moneda of tiposMoneda" [value]="moneda.codigoMoneda">
                  {{moneda.nombreMoneda}}
                </option>
              </select>
            </div>
          </div>
        </div>

        <button type="submit" [disabled]="!financieraForm.valid" class="continue-button">
          Continuar
        </button>

      </form>
    </ng-container>

    <!-- Step 4: Bienes y/o Inmuebles -->
    <ng-container *ngIf="visibleSteps[currentStep - 1]?.originalId === 4">
      <form [formGroup]="inmuebleForm" (ngSubmit)="onSubmit()" class="step-form">

        <!-- Inmueble 1 -->
        <div class="inmueble-section">
          <h3 class="inmueble-title">Información Inmueble 1</h3>
          <div formGroupName="inmueble1">
            <div class="form-row">
              <div class="form-group">
                <label>No. Matrícula Inmobiliaria:</label>
                <input type="text" formControlName="matricula" appUppercase>
              </div>

              <div class="form-group">
                <label>Dirección del Inmueble:</label>
                <input type="text" formControlName="direccion" appUppercase>
              </div>

              <div class="form-group">
                <label>Departamento del Inmueble:</label>
                <select formControlName="departamento">
                  <option value="null" disabled selected hidden>Seleccione...</option>
                  <option *ngFor="let dept of departments" [value]="dept.codigoDepartamento">
                    {{dept.nombreDepartamento}}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <label>Ciudad/Municipio del Inmueble:</label>
                <select formControlName="ciudad" [disabled]="!inmuebleForm.get('inmueble1.departamento')?.value">
                  <option value="null" disabled selected hidden>Seleccione...</option>
                  <option *ngFor="let mun of inmueble1Municipalities" [value]="mun.codigoMunicipio">
                    {{mun.nombreMunicipio}}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <label>Valor Comercial:</label>
                <div class="input-currency">
                  <span class="currency-symbol">$</span>
                  <input type="text" formControlName="valorComercial" (input)="formatNumber($event)">
                </div>
              </div>

              <div class="form-group">
                <label>Valor Hipoteca:</label>
                <div class="input-currency">
                  <span class="currency-symbol">$</span>
                  <input type="text" formControlName="valorHipoteca" (input)="formatNumber($event)">
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="inmueble-section">
          <h3 class="inmueble-title">Información Inmueble 2</h3>
          <div formGroupName="inmueble2">
            <div class="form-row">
              <div class="form-group">
                <label>No. Matrícula Inmobiliaria:</label>
                <input type="text" formControlName="matricula" appUppercase>
              </div>

              <div class="form-group">
                <label>Dirección del Inmueble:</label>
                <input type="text" formControlName="direccion" appUppercase>
              </div>

              <div class="form-group">
                <label>Departamento del Inmueble:</label>
                <select formControlName="departamento">
                  <option value="null" disabled selected hidden>Seleccione...</option>
                  <option *ngFor="let dept of departments" [value]="dept.codigoDepartamento">
                    {{dept.nombreDepartamento}}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <label>Ciudad/Municipio del Inmueble:</label>
                <select formControlName="ciudad" [disabled]="!inmuebleForm.get('inmueble2.departamento')?.value">
                  <option value="null" disabled selected hidden>Seleccione...</option>
                  <option *ngFor="let mun of inmueble2Municipalities" [value]="mun.codigoMunicipio">
                    {{mun.nombreMunicipio}}
                  </option>
                </select>
              </div>

              <div class="form-group">
                <label>Valor Comercial:</label>
                <div class="input-currency">
                  <span class="currency-symbol">$</span>
                  <input type="text" formControlName="valorComercial" (input)="formatNumber($event)">
                </div>
              </div>

              <div class="form-group">
                <label>Valor Hipoteca:</label>
                <div class="input-currency">
                  <span class="currency-symbol">$</span>
                  <input type="text" formControlName="valorHipoteca" (input)="formatNumber($event)">
                </div>
              </div>
            </div>
          </div>
        </div>

        <button type="submit" class="continue-button">
          Continuar
        </button>
      </form>
    </ng-container>

    <!-- Step 5: Vehículos -->
    <ng-container *ngIf="visibleSteps[currentStep - 1]?.originalId === 5">
      <form [formGroup]="vehiculosForm" (ngSubmit)="onSubmit()" class="step-form">

<!-- Vehículo 1 -->
<div class="vehiculo-section">
  <h3 class="vehiculo-title">Información Vehículo 1</h3>
  <div formGroupName="vehiculo1">
    <div class="form-row">
      <div class="form-group">
        <label>Marca de Vehículo:</label>
        <input type="text" formControlName="marca" appUppercase>
      </div>

      <div class="form-group">
        <label>Modelo:</label>
       <input type="text" formControlName="modelo" (input)="onlyNumbers($event, 'vehiculo1.modelo')">
      </div>

      <div class="form-group">
        <label>Placa:</label>
        <input type="text" formControlName="placa" appUppercase>
      </div>

      <div class="form-group">
        <label>Tiene Pignoración:</label>
        <div class="radio-container">
          <label class="radio-option">
            <input type="radio" formControlName="tienePignoracion" value="S"> Sí
          </label>
          <label class="radio-option">
            <input type="radio" formControlName="tienePignoracion" value="N"> No
          </label>
        </div>
      </div>
      
    </div>
  </div>
</div>


        <!-- Vehículo 2  -->
        <div class="vehiculo-section">
          <h3 class="vehiculo-title">Información Vehículo 2</h3>
          <div formGroupName="vehiculo2">
            <div class="form-row">
              <div class="form-group">
                <label>Marca de Vehículo:</label>
                <input type="text" formControlName="marca" appUppercase>
              </div>

              <div class="form-group">
                <label>Modelo:</label>
                <input type="text" formControlName="modelo" (input)="onlyNumbers($event, 'vehiculo2.modelo')">
              </div>

              <div class="form-group">
                <label>Placa:</label>
                <input type="text" formControlName="placa" appUppercase>
              </div>

              <div class="form-group">
                <label>Tiene Pignoración:</label>
                <div class="radio-container">
                  <label class="radio-option">
                    <input type="radio" formControlName="tienePignoracion" value="S"> Sí
                  </label>
                  <label class="radio-option">
                    <input type="radio" formControlName="tienePignoracion" value="N"> No
                  </label>
                </div>
              </div>              
            </div>
          </div>
        </div>

        <button type="submit" class="continue-button">
          Continuar
        </button>
      </form>
    </ng-container>

    <!-- Step 6: Conyuge -->
    <ng-container *ngIf="visibleSteps[currentStep - 1]?.originalId === 6">
      <form [formGroup]="spouseForm" (ngSubmit)="onSubmit()" class="step-form">
        <!-- Primera fila -->
        <div class="form-row four-columns">
          <div class="form-group">
            <label>Tipo de Documento:</label>
            <select formControlName="idDocumentType">
              <option value="null" disabled selected hidden>Seleccione...</option>
              <option *ngFor="let type of spouseDocumentTypes" [value]="type.codigoTipoDocumento">
                {{type.nombreTipoDocumento}}
              </option>
            </select>
          </div>

          <div class="form-group">
            <label>Número de Documento:</label>
            <input type="text" formControlName="documentNumber">
          </div>

          <div class="form-group">
            <label>Fecha de Expedición Documento:</label>
            <input type="date" formControlName="expeditionDate">
          </div>

          <div class="form-group">
            <label>Correo Electrónico:</label>
            <input type="email" formControlName="email">
            <small class="error-message"
              *ngIf="spouseForm.get('email')?.touched && spouseForm.get('email')?.hasError('email')">
              Ingrese un correo electrónico válido
            </small>
          </div>
        </div>

        <!-- Segunda fila -->
        <div class="form-row four-columns">
          <div class="form-group">
            <label>Primer Apellido:</label>
            <input type="text" formControlName="firstLastName" appUppercase>
          </div>

          <div class="form-group">
            <label>Segundo Apellido:</label>
            <input type="text" formControlName="secondLastName" appUppercase>
          </div>

          <div class="form-group">
            <label>Primer Nombre:</label>
            <input type="text" formControlName="firstName" appUppercase>
          </div>

          <div class="form-group">
            <label>Segundo Nombre:</label>
            <input type="text" formControlName="secondName" appUppercase>
          </div>
        </div>

        <!-- Tercera fila -->
        <div class="form-row four-columns">
          <div class="form-group">
            <label>Nombre de la Empresa:</label>
            <input type="text" formControlName="companyName" appUppercase>
          </div>

          <div class="form-group">
            <label>Dirección Oficina:</label>
            <input type="text" formControlName="officeAddress" appUppercase>
          </div>

          <div class="form-group">
            <label>Teléfono:</label>
            <input type="tel" formControlName="officePhone">
          </div>

          <div class="form-group">
            <label>Profesión u Oficio:</label>
            <select formControlName="occupation">
              <option value="null" disabled selected hidden>Seleccione...</option>
              <option *ngFor="let ocupacion of tiposOcupacion" [value]="ocupacion.codigoOcupacion">
                {{ocupacion.nombreOcupacion}}
              </option>
            </select>
          </div>
        </div>

        <!-- Cuarta fila -->
        <div class="form-row three-columns">
          <div class="form-group">
            <label>Sueldo:</label>
            <div class="input-currency">
              <span class="currency-symbol">$</span>
              <input type="text" formControlName="salary" (input)="formatNumber($event)">
            </div>
          </div>

          <div class="form-group">
            <label>Nombre Propietario Inmueble:</label>
            <input type="text" formControlName="propertyOwnerName" appUppercase>
            <small class="hint-message">
              SI EL INMUEBLE EN QUE RESIDE ES ARRENDADO, INDIQUE EL NOMBRE DEL PROPIETARIO
            </small>
          </div>

          <div class="form-group">
            <label>Teléfono:</label>
            <input type="tel" formControlName="phone">
          </div>
        </div>

        <button type="submit" class="continue-button">
          Continuar
        </button>
      </form>
    </ng-container>

    <!-- Step 7: Reclamaciones -->
    <ng-container *ngIf="visibleSteps[currentStep - 1]?.originalId === 7">
      <form [formGroup]="claimsForm" (ngSubmit)="onSubmit()" class="step-form">
        <div class="form-row claims-row">
          <div class="form-group">
            <label>Año:</label>
            <input type="number" formControlName="year" min="1900" [max]="currentYear">
          </div>

          <div class="form-group">
            <label>Ramo:</label>
            <input type="text" formControlName="branch" appUppercase>
          </div>

          <div class="form-group">
            <label>Compañía:</label>
            <input type="text" formControlName="company" appUppercase>
          </div>

          <div class="form-group">
            <label>Valor:</label>
            <div class="input-currency">
              <span class="currency-symbol">$</span>
              <input type="text" formControlName="value" (input)="formatNumber($event)">
            </div>
          </div>

          <div class="form-group checkbox-group-claims">
            <div class="checkbox-options">
              <label>
                <input type="checkbox" formControlName="hasClaim">
                Reclamación
              </label>
              <label>
                <input type="checkbox" formControlName="hasCompensation">
                Indemnización
              </label>
            </div>
          </div>
        </div>

        <button type="submit" class="continue-button">
          Continuar
        </button>
      </form>
    </ng-container>

    <!-- Step 8: Referencias -->
    <ng-container *ngIf="visibleSteps[currentStep - 1]?.originalId === 8">
      <form [formGroup]="referencesForm" (ngSubmit)="onSubmit()" class="step-form">
        <div formArrayName="references">
          <ng-container *ngFor="let reference of getReferences().controls; let i = index">
            <div [formGroupName]="i" class="reference-section">
              <h3 class="reference-title">Referencia {{i + 1}}</h3>

              <!-- Reference Type Selection -->
              <div class="form-row type-selector">
                <div class="form-group">
                  <label>Tipo de Referencia: <span class="required-field">*</span></label>
                  <select formControlName="referenceType" (change)="onReferenceTypeChange(i)">
                    <option value="null" disabled selected hidden>Seleccione...</option>
                    <option *ngFor="let type of referenceTypes" 
                            [ngValue]="type.inIdReferenceType"
                            [disabled]="isReferenceTypeSelected(type.inIdReferenceType, i)">
                      {{type.strReferenceType}}
                    </option>
                  </select>
                  <small class="error-message" *ngIf="reference.get('referenceType')?.touched && 
                   reference.get('referenceType')?.hasError('required')">
                    Este campo es requerido
                  </small>
                </div>
              </div>

              <!-- Conditional Fields based on Reference Type -->
              <ng-container [ngSwitch]="reference.get('referenceType')?.value">
                <!-- Bank Reference -->
                <ng-container *ngSwitchCase="1">
                  <div class="reference-fields">
                    <div class="form-group">
                      <label>Entidad: <span class="required-field">*</span></label>
                      <input type="text" formControlName="entity" appUppercase>
                      <small class="error-message" *ngIf="reference.get('entity')?.touched && 
                       reference.get('entity')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>

                    <div class="form-group">
                      <label>Cuenta: <span class="required-field">*</span></label>
                      <input type="text" formControlName="account">
                      <small class="error-message" *ngIf="reference.get('account')?.touched && 
                       reference.get('account')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>

                    <div class="form-group">
                      <label>Sucursal: <span class="required-field">*</span></label>
                      <input type="text" formControlName="branch" appUppercase>
                      <small class="error-message" *ngIf="reference.get('branch')?.touched && 
                       reference.get('branch')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>

                    <div class="form-group">
                      <label>Departamento: <span class="required-field">*</span></label>
                      <select formControlName="department" (change)="onDepartmentChange(i, $any($event.target).value)">
                        <option value="null" disabled selected hidden>Seleccione...</option>
                        <option *ngFor="let dept of departments" [value]="dept.codigoDepartamento">
                          {{dept.nombreDepartamento}}
                        </option>
                      </select>
                      <small class="error-message" *ngIf="reference.get('department')?.touched && 
                       reference.get('department')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>

                    <div class="form-group">
                      <label>Ciudad/Municipio: <span class="required-field">*</span></label>
                      <select formControlName="city">
                        <option value="null" disabled selected hidden>Seleccione...</option>
                        <option *ngFor="let mun of referenceMunicipalities[i]" [value]="mun.codigoMunicipio">
                          {{mun.nombreMunicipio}}
                        </option>
                      </select>
                      <small class="error-message" *ngIf="reference.get('city')?.touched && 
                       reference.get('city')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>
                  </div>
                </ng-container>

                <!-- Personal Reference -->
                <ng-container *ngSwitchCase="2">
                  <div class="reference-fields">
                    <div class="form-group">
                      <label>Nombre: <span class="required-field">*</span></label>
                      <input type="text" formControlName="name" appUppercase>
                      <small class="error-message" *ngIf="reference.get('name')?.touched && 
                       reference.get('name')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>

                    <div class="form-group">
                      <label>Parentesco: <span class="required-field">*</span></label>
                      <input type="text" formControlName="relationship" appUppercase>
                      <small class="error-message" *ngIf="reference.get('relationship')?.touched && 
                       reference.get('relationship')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>

                    <div class="form-group">
                      <label>Teléfono: <span class="required-field">*</span></label>
                      <input type="tel" formControlName="phone">
                      <small class="error-message" *ngIf="reference.get('phone')?.touched && 
                       reference.get('phone')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>

                    <div class="form-group">
                      <label>Departamento: <span class="required-field">*</span></label>
                      <select formControlName="department" (change)="onDepartmentChange(i, $any($event.target).value)">
                        <option value="null" disabled selected hidden>Seleccione...</option>
                        <option *ngFor="let dept of departments" [value]="dept.codigoDepartamento">
                          {{dept.nombreDepartamento}}
                        </option>
                      </select>
                      <small class="error-message" *ngIf="reference.get('department')?.touched && 
                       reference.get('department')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>

                    <div class="form-group">
                      <label>Ciudad/Municipio: <span class="required-field">*</span></label>
                      <select formControlName="city">
                        <option value="null" disabled selected hidden>Seleccione...</option>
                        <option *ngFor="let mun of referenceMunicipalities[i]" [value]="mun.codigoMunicipio">
                          {{mun.nombreMunicipio}}
                        </option>
                      </select>
                      <small class="error-message" *ngIf="reference.get('city')?.touched && 
                       reference.get('city')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>
                  </div>
                </ng-container>

                <!-- Commercial Reference -->
                <ng-container *ngSwitchCase="3">
                  <div class="reference-fields">
                    <div class="form-group">
                      <label>Nombre: <span class="required-field">*</span></label>
                      <input type="text" formControlName="name" appUppercase>
                      <small class="error-message" *ngIf="reference.get('name')?.touched && 
                       reference.get('name')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>

                    <div class="form-group">
                      <label>Dirección: <span class="required-field">*</span></label>
                      <input type="text" formControlName="address" appUppercase>
                      <small class="error-message" *ngIf="reference.get('address')?.touched && 
                       reference.get('address')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>

                    <div class="form-group">
                      <label>Teléfono: <span class="required-field">*</span></label>
                      <input type="tel" formControlName="phone">
                      <small class="error-message" *ngIf="reference.get('phone')?.touched && 
                       reference.get('phone')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>

                    <div class="form-group">
                      <label>Departamento: <span class="required-field">*</span></label>
                      <select formControlName="department" (change)="onDepartmentChange(i, $any($event.target).value)">
                        <option value="null" disabled selected hidden>Seleccione...</option>
                        <option *ngFor="let dept of departments" [value]="dept.codigoDepartamento">
                          {{dept.nombreDepartamento}}
                        </option>
                      </select>
                      <small class="error-message" *ngIf="reference.get('department')?.touched && 
                       reference.get('department')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>

                    <div class="form-group">
                      <label>Ciudad/Municipio: <span class="required-field">*</span></label>
                      <select formControlName="city">
                        <option value="null" disabled selected hidden>Seleccione...</option>
                        <option *ngFor="let mun of referenceMunicipalities[i]" [value]="mun.codigoMunicipio">
                          {{mun.nombreMunicipio}}
                        </option>
                      </select>
                      <small class="error-message" *ngIf="reference.get('city')?.touched && 
                       reference.get('city')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>
                  </div>
                </ng-container>

                <!-- Labor Reference -->
                <ng-container *ngSwitchCase="4">
                  <div class="reference-fields">
                    <div class="form-group">
                      <label>Nombre: <span class="required-field">*</span></label>
                      <input type="text" formControlName="name" appUppercase>
                      <small class="error-message" *ngIf="reference.get('name')?.touched && 
                       reference.get('name')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>

                    <div class="form-group">
                      <label>Teléfono: <span class="required-field">*</span></label>
                      <input type="tel" formControlName="phone">
                      <small class="error-message" *ngIf="reference.get('phone')?.touched && 
                       reference.get('phone')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>

                    <div class="form-group">
                      <label>Departamento: <span class="required-field">*</span></label>
                      <select formControlName="department" (change)="onDepartmentChange(i, $any($event.target).value)">
                        <option value="null" disabled selected hidden>Seleccione...</option>
                        <option *ngFor="let dept of departments" [value]="dept.codigoDepartamento">
                          {{dept.nombreDepartamento}}
                        </option>
                      </select>
                      <small class="error-message" *ngIf="reference.get('department')?.touched && 
                       reference.get('department')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>

                    <div class="form-group">
                      <label>Ciudad/Municipio: <span class="required-field">*</span></label>
                      <select formControlName="city">
                        <option value="null" disabled selected hidden>Seleccione...</option>
                        <option *ngFor="let mun of referenceMunicipalities[i]" [value]="mun.codigoMunicipio">
                          {{mun.nombreMunicipio}}
                        </option>
                      </select>
                      <small class="error-message"
                        *ngIf="reference.get('city')?.touched && reference.get('city')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>
                  </div>
                </ng-container>

                <!-- Credit Reference -->
                <ng-container *ngSwitchCase="5">
                  <div class="reference-fields">
                    <div class="form-group">
                      <label>Nombre: <span class="required-field">*</span></label>
                      <input type="text" formControlName="name" appUppercase>
                      <small class="error-message" *ngIf="reference.get('name')?.touched && 
                       reference.get('name')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>

                    <div class="form-group">
                      <label>Cupo Actual: <span class="required-field">*</span></label>
                      <div class="input-currency">
                        <span class="currency-symbol">$</span>
                        <input type="text" formControlName="currentQuota" (input)="formatNumber($event)">
                      </div>
                      <small class="error-message" *ngIf="reference.get('currentQuota')?.touched && 
                       reference.get('currentQuota')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>

                    <div class="form-group">
                      <label>Cuota Mensual: <span class="required-field">*</span></label>
                      <div class="input-currency">
                        <span class="currency-symbol">$</span>
                        <input type="text" formControlName="monthlyQuota" (input)="formatNumber($event)">
                      </div>
                      <small class="error-message" *ngIf="reference.get('monthlyQuota')?.touched && 
                       reference.get('monthlyQuota')?.hasError('required')">
                        Este campo es requerido
                      </small>
                    </div>
                  </div>
                </ng-container>
              </ng-container>
            </div>
          </ng-container>
        </div>

        <button type="submit" [disabled]="!allReferencesValid()" class="continue-button">
          Continuar
        </button>
      </form>
    </ng-container>

    <!-- Step 9: PPE -->
    <ng-container *ngIf="visibleSteps[currentStep - 1]?.originalId === 9">
      <form [formGroup]="ppeForm" (ngSubmit)="onSubmit()" class="step-form">
        <div class="ppe-checkboxes">
          <div class="checkbox-item">
            <input type="checkbox" id="publicRecognition" formControlName="publicRecognition">
            <label for="publicRecognition">¿Es usted una persona de reconocimiento público?</label>
          </div>

          <div class="checkbox-item">
            <input type="checkbox" id="holdsPublicOffice" formControlName="holdsPublicOffice">
            <label for="holdsPublicOffice">¿Es usted una persona que ejerce cargos públicos?</label>
          </div>

          <div class="checkbox-item">
            <input type="checkbox" id="isPpeFamilyMember" formControlName="isPpeFamilyMember">
            <label for="isPpeFamilyMember">¿Es usted familiar de una PPE?</label>
          </div>
        </div>

        <div class="ppe-fields" *ngIf="ppeForm.get('isPpeFamilyMember')?.value">
          <!-- Grupo 1 -->
          <div class="ppe-group">
            <div class="form-row">
              <div class="form-group">
                <label>Número Documento PPE:</label>
                <input type="text" formControlName="ppeDocumentNumber1">
              </div>

              <div class="form-group">
                <label>Entidad/Nombre:</label>
                <input type="text" formControlName="entityName1" appUppercase>
              </div>

              <div class="form-group">
                <label>Vínculo PPE:</label>
                <input type="text" formControlName="ppeRelation1" appUppercase>
              </div>
            </div>
          </div>

          <!-- Grupo 2 -->
          <div class="ppe-group">
            <div class="form-row">
              <div class="form-group">
                <label>Número Documento PPE:</label>
                <input type="text" formControlName="ppeDocumentNumber2">
              </div>

              <div class="form-group">
                <label>Entidad/Nombre:</label>
                <input type="text" formControlName="entityName2" appUppercase>
              </div>

              <div class="form-group">
                <label>Vínculo PPE:</label>
                <input type="text" formControlName="ppeRelation2" appUppercase>
              </div>
            </div>
          </div>

          <!-- Grupo 3 -->
          <div class="ppe-group">
            <div class="form-row">
              <div class="form-group">
                <label>Número Documento PPE:</label>
                <input type="text" formControlName="ppeDocumentNumber3">
              </div>

              <div class="form-group">
                <label>Entidad/Nombre:</label>
                <input type="text" formControlName="entityName3" appUppercase>
              </div>

              <div class="form-group">
                <label>Vínculo PPE:</label>
                <input type="text" formControlName="ppeRelation3" appUppercase>
              </div>
            </div>
          </div>
        </div>

        <div class="ppe-note">
          <h4>Nota: Persona Públicamente Expuesta (PPE)</h4>
          <p>
            I) Las personas expuestas políticamente, II) los representantes legales de organizaciones internacionales y
            III) las personas que gozan de reconocimiento público. Se entiende por persona políticamente expuesta
            conforme a la regulación vigente, los individuos que desempeñan o han desempeñado funciones públicas
            destacadas como jefes de Estado, políticos de alta jerarquía, funcionarios gubernamentales, judiciales o
            militares de alta jerarquía, altos ejecutivos (Directores y Gerentes) de empresas sociales, industriales y
            comerciales del estado y de sociedades de economía mixta, unidades administrativas especiales, y
            funcionarios importantes de partidos políticos. **Vinculo / Relación**: I) Segundo grado de consanguinidad
            (padres, abuelos, hermanos, hijos, nietos). II) Segundo de afinidad (yernos, nueras, suegros, cuñados,
            abuelos del cónyuge o compañero/a permanente de la PPE), y III) Primero civil (hijos adoptivos o padres
            adoptantes).
          </p>
        </div>

        <button type="submit" class="continue-button">
          Continuar
        </button>
      </form>
    </ng-container>

    <!-- Step 10: Declaraciones -->
    <ng-container *ngIf="visibleSteps[currentStep - 1]?.originalId === 10">
      <form [formGroup]="declarationsForm" (ngSubmit)="onSubmit()" class="step-form">
        <div class="declarations-section">
          <h3>Declaro expresamente que:</h3>
          <ol class="declarations-list">
            <li>Tanto mi actividad, profesión u oficio es lícita y la ejerzo dentro del marco legal y los recursos que
              poseo no provienen de actividades ilícitas de las contempladas en el Código Penal Colombiano.</li>
            <li>La información que he suministrado en éste formato es veraz y verificable, y me obligo a confirmar los
              datos suministrados y anualmente a actualizarla conforme a los procedimientos que para tal efecto tenga
              establecidos la Aseguradora Solidaria de Colombia Entidad Cooperativa. El incumplimiento de esta
              obligación faculta a la Aseguradora para revocar unilateralmente el contrato. Los recursos que se deriven
              del desarrollo de éste contrato no se destinarán a la financiación del terrorismo, grupos terroristas o
              actividades terroristas.</li>
            <li>Las declaraciones contenidas en éste documento son exactas, completas y verídicas en la forma en que
              aparecen escritas.</li>
            <li>Manifiesto que no he sido declarado responsable judicialmente por la comisión de delitos contra la
              Administración Pública cuya pena sea privativa de la libertad o que afecten el patrimonio del Estado o por
              delitos relacionados con la pertenencia, promoción o financiación de grupos ilegales, delitos de lesa
              humanidad, narcotráfico en Colombia o en el exterior, o soborno transnacional.</li>
            <li>Los recursos que poseo provienen de las siguientes fuentes (detalle ocupación, oficio, actividad o
              negocio):</li>
          </ol>

          <div class="form-group">
            <label>Origen Ingresos: <span class="required-field">*</span></label>
            <input type="text" formControlName="incomeSource" appUppercase>
            <small class="error-message" *ngIf="declarationsForm.get('incomeSource')?.touched && 
         declarationsForm.get('incomeSource')?.hasError('required')">
              Este campo es requerido
            </small>
          </div>
        </div>

        <button type="submit" [disabled]="!declarationsForm.valid" class="continue-button">
          Continuar
        </button>
      </form>
    </ng-container>

    <!-- Step 11: Autorizaciones -->
    <ng-container *ngIf="visibleSteps[currentStep - 1]?.originalId === 11">
      <form [formGroup]="authorizationsForm" (ngSubmit)="onSubmit()" class="step-form">
        <div class="authorizations-section">
          <h2 style="text-align: center;">AUTORIZACIÓN PARA EL TRATAMIENTO DE DATOS PERSONALES</h2>
          <p class="intro-text">
            Declaro que <strong>ASEGURADORA SOLIDARIA DE COLOMBIA ENTIDAD COOPERATIVA</strong> me ha informado: 1) Que la política de tratamiento de datos y el Manual de Tratamiento de Datos Personales se encuentran en la página web: <a href="https://www.aseguradorasolidaria.com.co">https://www.aseguradorasolidaria.com.co</a>; 2) Que son facultativas las respuestas a las preguntas sobre datos de niñas, niños, adolescentes y aquellas que versen sobre datos sensibles y en consecuencia no he sido obligado a responderlas; 3) Que como titular de la información, me asisten los derechos previstos en las leyes 1266 de 2008 y 1581 de 2012. En especial, me asiste el derecho a conocer, actualizar, rectificar, revocar y suspender las informaciones que se hayan recogido sobre mí, derecho que se puede ejercer a través de la línea de protección de datos establecida en la página web y el correo electrónico <a href="mailto:tratamientodatos&#64;solidaria.com.co">tratamientodatos&#64;solidaria.com.co</a>.
          </p>
          
          <p class="intro-text">
            Autorizo de manera previa, expresa e informada a <strong>ASEGURADORA SOLIDARIA DE COLOMBIA ENTIDAD COOPERATIVA</strong> y/o cualquier sociedad controlada, directamente o indirectamente, que tengan participación accionaria o sean asociados, domiciliadas en Colombia y/o en el exterior, terceros contratados por esta o a quien la represente, en adelante <strong>LA ASEGURADORA</strong>, que actuará como Responsable del tratamiento y en tal virtud podrá recolectar, solicitar, consultar, verificar, almacenar, compartir, enviar, reportar, modificar, transferir, transmitir, actualizar, usar, grabar y conservar mis datos personales, incluyendo datos financieros, crediticios, sensibles y de menores en calidad de su representante legal, para las siguientes finalidades:
          </p>
          
          <p class="intro-text">
            i) El trámite de mi solicitud de vinculación como consumidor financiero, deudor, contraparte contractual y/o proveedor. ii) El proceso de negociación de contratos con LA ASEGURADORA, incluyendo la determinación de primas, la selección de riesgos y toda la fase precontractual. iii) La ejecución y el cumplimiento de los contratos que celebre. iv) El control y la prevención del fraude. v) La liquidación y pago de siniestros. vi) Todo lo que involucre la gestión integral del seguro contratado, incluida la gestión y cobro de cartera. vii) Controlar el cumplimiento de requisitos para acceder al Sistema General de Seguridad Social Integral. viii) La elaboración de estudios técnico-actuariales, estadísticas, encuestas, análisis de tendencias del mercado y, en general, estudios de técnica aseguradora. ix) Envío de información relativa a la educación financiera, encuestas de satisfacción de clientes y ofertas comerciales de seguros, así como de otros servicios inherentes a la actividad aseguradora. x) Realización de encuestas sobre satisfacción en los servicios prestados por LA ASEGURADORA Y/O EL INTERMEDIARIO DE SEGUROS. xi) Intercambio o remisión de información en virtud de tratados y acuerdos internacionales e intergubernamentales suscritos por Colombia. xii) La prevención y control del lavado de activos y la financiación del terrorismo. xiii) Recolectar mis datos personales sensibles como: datos biométricos, las huellas dactilares, la Historia Clínica y datos sobre mi estado de salud, aún después de mi fallecimiento, entendiéndose la posibilidad de obtener copia de mi historia clínica, siempre y cuando se cumpla con lo previsto en el artículo 6 de la ley 1581 de 2012. xiv) Recolectar los datos personales de mis hijos menores de edad en mi calidad de su representante legal, siempre y cuando se cumpla con el interés prevalente del menor conforme al artículo 12 del decreto 1377 de 2013. xv) Transferir mis datos personales a terceros países siempre que se requiera cumplir las finalidades descritas o se encuentre estipulada por el artículo 26 de la ley 1581 de 2012.
          </p>
          
          <p class="intro-text">
            El tratamiento podrá ser realizado directamente por LA ASEGURADORA o por los encargados del tratamiento que ella considere necesarios. Que los datos podrán ser compartidos, transmitidos, entregados, transferidos o divulgados para las finalidades mencionadas, a:
          </p>
          
          <p class="intro-text">
            i) Las personas jurídicas que tienen la calidad de filiales, subsidiarias o vinculadas, o de matriz de LA ASEGURADORA. ii) Los operadores necesarios para el cumplimiento de derechos y obligaciones derivados de los contratos celebrados con LA ASEGURADORA Y/O EL INTERMEDIARIO DE SEGUROS, tales como: ajustadores, call centers, investigadores, compañías de asistencia, abogados externos, entre otros. iii) LOS INTERMEDIARIOS DE SEGUROS que intervengan en el proceso de celebración, ejecución y terminación del contrato de seguro. iv) Las personas con las cuales LA ASEGURADORA Y/O EL INTERMEDIARIO DE SEGUROS adelante gestiones para efectos de celebrar contratos de Coaseguro o Reaseguro. v) FASECOLDA, INVERFAS S.A. y el INIF, personas jurídicas que administran bases de datos para efectos de prevención y control de fraudes, la selección de riesgos, y control de requisitos para acceder al Sistema General de Seguridad Social Integral, así como la elaboración de estudios estadísticos actuariales.
          </p>
          
          <p class="intro-text">
            <strong>RESPONSABLES Y ENCARGADOS DEL TRATAMIENTO DE LA INFORMACIÓN:</strong> Que el Responsable del tratamiento de la información es LA ASEGURADORA. En todo caso, los encargados del Tratamiento de los datos que se compartan, transfieran, transmitan, entreguen o divulguen, en desarrollo de lo previsto en el literal v) del párrafo anterior, serán entre otros:
          </p>
          
          <ul>
            <li><strong>FASECOLDA</strong>: Carrera 7 No. 26 - 20 Pisos 11 y 12, email: <a href="mailto:fasecolda&#64;fasecolda.com">fasecolda&#64;fasecolda.com</a>, Tel. 3443080 de la ciudad de Bogotá D.C.</li>
            <li><strong>INVERFAS S.A.</strong>: Carrera 7 No. 26 - 20 Piso 11, email: <a href="mailto:inverfas&#64;fasecolda.com">inverfas&#64;fasecolda.com</a>, Tel. 3443080 de la ciudad de Bogotá D.C.</li>
            <li><strong>INIF - Instituto Nacional de Investigación y Prevención del Fraude al Seguro</strong>: Carrera 13 No. 37-43, piso 8, email: <a href="mailto:directoroperativo&#64;inif.com.co">directoroperativo&#64;inif.com.co</a>
              , Tel. 2320105 de la ciudad de Bogotá D.C.</li>
          </ul>
          
          <p class="intro-text">
            Con la firma en el presente documento, de manera expresa <strong>AUTORIZO</strong> el Tratamiento de los datos personales, incluidos los sensibles y de menores en calidad de su representante legal, y autorizo, de ser necesario, la transferencia nacional e internacional de los mismos, por las personas, para las finalidades y en los términos que me fueron informados en este documento.
          </p>
        </div>
        

        <button type="submit" class="continue-button">
          Grabar Información
        </button>
      </form>
    </ng-container>
  </div>
</div>